module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_vii",
      "title": "vii"
    }
  }, [_vm._v("As the surgeon’s scalpel reveals my organs, love introduces other versions of myself, whose obscene novelty disgusts me.")])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_vm._v("—"), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_span-accent-characters-acc-_CAPS"
  }, [_vm._v("É")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DOUARD")]), _vm._v(" "), _c('span', {
    staticClass: "fm-epigraph-source-fmeps-_CAPS"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("EVÉ")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Autoportrait")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0